import React from 'react';
import { Redirect } from 'react-router-dom';

import * as ROUTES from '../../constants/routes';

const SignUpPage = () => (
  <Redirect to={ROUTES.SIGN_IN} />
);

const SignUpLink = () => (
  <p>
    Heb je nog geen account? Neem contact op met sQoot & Bike.
  </p>
)

export default SignUpPage;

export { SignUpLink };
